<template>
    <!-- 全局导航退出组件 -->
    <div :class="['layout-inline-menu', {'layout-inline-menu-active': activeInlineProfile}] "
         v-if='false'>
        <a class='layout-inline-menu-action' @click='onChangeActiveInlineMenu'>
            <img src='layout/images/profile-image.png' alt='avatar' style='width: 44px; height: 44px;'>
            <span class='layout-inline-menu-text'
                  style="width:7.5rem;font-weight: bold;word-wrap: break-word;white-space: break-spaces;">{{ firstName+" "+lastName }}</span>
            <i class='layout-inline-menu-icon pi pi-angle-down'></i>
        </a>

        <transition name='layout-inline-menu-action-panel'>
            <ul v-show='activeInlineProfile' class='layout-inline-menu-action-panel'>
                <li class="layout-inline-menu-action-item userLi">
                    <el-popover placement="right-end" @before-enter="nameShow" transition="el-zoom-in-top" :width="450"
                                trigger="hover">
                        <template #reference>
                            <a>
                                <i class="pi pi-user pi-fw"></i>
                                <span class='userInfo' style="width:9rem;">
									<p style="word-wrap: break-word;white-space: break-spaces;">{{micAccountName}}</p>
								</span>
                            </a>
                        </template>
                        <ScrollPanel style="height: 200px" class="custom">
                            <div v-for="(item,index) in list" :class="['company',index%2==1?'other':'']" :key="index">
                                <div style="font-weight:bold;margin-bottom:5px;">
                                    <i class="pi pi-bookmark-fill"></i>
                                    {{item.clientName}}
                                </div>
                                <div>
                                    <i class="pi pi-id-card"></i>
                                    {{item.title}}
                                </div>
                            </div>
                        </ScrollPanel>
                    </el-popover>
                </li>
                <li class='layout-inline-menu-action-item userLi' @click='onLogOut'>
                    <a>
                        <i class='pi pi-power-off pi-fw'></i>
                        <span>Logout</span>
                    </a>
                </li>
            </ul>
        </transition>
    </div>
</template>


<!--<template>
	&lt;!&ndash; 全局导航退出组件 &ndash;&gt;
	<div :class="['layout-inline-menu', {'layout-inline-menu-active': activeInlineProfile}]"
		v-if='!isMobile() && (isStatic() || isSlim() || isSidebar())'>
		<a class='layout-inline-menu-action' @click='onChangeActiveInlineMenu'>
			<img src='layout/images/profile-image.png' alt='avatar' style='width: 44px; height: 44px;'>
			<span class='layout-inline-menu-text'
				style="width:7.5rem;font-weight: bold;word-wrap: break-word;white-space: break-spaces;">{{ firstName+" "+lastName }}</span>
			<i class='layout-inline-menu-icon pi pi-angle-down'></i>
		</a>

		<transition name='layout-inline-menu-action-panel'>
			<ul v-show='activeInlineProfile' class='layout-inline-menu-action-panel'>
&lt;!&ndash;				<li class="layout-inline-menu-action-item userLi">
					<el-popover placement="right-end" @before-enter="nameShow" transition="el-zoom-in-top" :width="450"
						trigger="hover">
						<template #reference>
							<a>
								<i class="pi pi-user pi-fw"></i>
								<span class='userInfo' style="width:9rem;">
									<p style="word-wrap: break-word;white-space: break-spaces;">{{micAccountName}}</p>
								</span>
							</a>
						</template>

&lt;!&ndash;						<ScrollPanel style="height: 200px" class="custom">
&lt;!&ndash;							<div v-for="(item,index) in list" :class="['company',index%2==1?'other':'']" :key="index">
								<div style="font-weight:bold;margin-bottom:5px;">
									<i class="pi pi-bookmark-fill"></i>
									{{item.clientName}}
								</div>
								<div>
									<i class="pi pi-id-card"></i>
									{{item.title}}
								</div>
							</div>&ndash;&gt;
                      &lt;!&ndash;   增加可选择跳转的按钮 &ndash;&gt;

						</ScrollPanel>&ndash;&gt;
					</el-popover>
				</li>&ndash;&gt;

                <li class='layout-inline-menu-action-item userLi' @click='onJumptoPortal'>
                    <a>
                        <i class='pi pi-home pi-fw'></i>
                        <span>Jump to portal</span>
                    </a>
                </li>
                <li class='layout-inline-menu-action-item userLi' @click='onJumptoReportingSystem'>
                    <a>
                        <i class='pi pi-star pi-fw'></i>
                        <span>Jump reporting system</span>
                    </a>
                </li>
				<li class='layout-inline-menu-action-item userLi' @click='onLogOut'>
					<a>
						<i class='pi pi-power-off pi-fw'></i>
						<span>Logout</span>
					</a>
				</li>
			</ul>
		</transition>
	</div>
</template>-->

<script>
	import router from './router';

	export default {
		name: 'AppInlineMenu',
		emits: ['change-inlinemenu'],
		props: {
			menuMode: String,
			activeInlineProfile: {
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				clientName: localStorage.getItem('clientName'),
				micAccountName: localStorage.getItem('micAccountName'),
				// userName: localStorage.getItem('userName'),
				firstName: localStorage.getItem('firstName'),
				lastName: localStorage.getItem('lastName'),
				title: localStorage.getItem('title'),
				list: []
			};
		},
		methods: {
			nameShow() {
				this.list = []
				let titleList = this.title.split(',')
				let clientNameList = this.clientName.split(',')

				for (let i = 0; i < titleList.length; i++) {
					this.list.push({
						title: titleList[i],
						clientName: clientNameList[i]
					})
				}
			},
			onChangeActiveInlineMenu(event) {
				this.$emit('change-inlinemenu', event);
				event.preventDefault();
			},
			isHorizontal() {
				return this.menuMode === 'horizontal';
			},
			isSlim() {
				return this.menuMode === 'slim';
			},
			isOverlay() {
				return this.menuMode === 'overlay';
			},
			isStatic() {
				return this.menuMode === 'static';
			},
			isSidebar() {
				return this.menuMode === 'sidebar';
			},
			isDesktop() {
				return window.innerWidth > 991;
			},
			isMobile() {
				return window.innerWidth <= 991;
			},
			onLogOut: async function() {
				// await fetchRequest('/api/biolims/logout', 'post',{token: 'bio-token',userid: 1})
				if (localStorage.getItem('token')) {
					localStorage.removeItem('token');
				}
				if (localStorage.getItem('userName')) {
					localStorage.removeItem('userName');
				}
				if (localStorage.getItem('language')) {
					localStorage.setItem('language', 'zh_CN');
				}
				if (localStorage.getItem('X-DS')) {
					localStorage.removeItem('X-DS');
				}
				if (localStorage.getItem('router')) {
					localStorage.removeItem('router');
				}
				router.push({
					path: '/'
				});
			},
            //跳转到门户
            onJumptoPortal : async function(){
                var user = localStorage.getItem("micAccountName");
                var sid = localStorage.getItem("sessionId");
                window.location.href = "https://p3-demo.predicine.com/index?sid="+sid+"&loginHint="+user;
            },
            //跳转到报告系统
            onJumptoReportingSystem : async function(){

            },
		},
	};
</script>

<style>
	.userInfo {
		display: block;
		width: 145px;
	}
	.custom .p-scrollpanel-wrapper {
	    border-right: 9px solid #f4f4f4;
	}
	
	.custom .p-scrollpanel-bar {
	    background-color: #1976d2;
	    opacity: 1;
	    transition: background-color .3s;
	}
	.p-scrollpanel-bar-x{
		display: none;
	}
	.custom .p-scrollpanel-bar:hover {
	    background-color: #135ba1;
	}
	.company{
		padding:2px 0;
		padding-left:15px;
		text-align:left;
		border-radius: 5px;
		margin-bottom:4px;
	}
	.other{
		background:#f2f4fb;
	}
</style>